import {StoragePromoCodeRepository} from '@domain/model/PromoCode/StoragePromoCodeRepository';

const ClearBoxRequestPromoCode = (repository: StoragePromoCodeRepository) => (): void => {
  return repository.clearPromoBoxRequest();
};

export {ClearBoxRequestPromoCode};
